import { createContext, useEffect, useState } from "react";
export const UserContext = createContext();

export default function UserContextProvider(props) {
  const [userLoggedIn, setUserLoggedIn] = useState(!!localStorage.getItem("token"));
  const [userToken, setUserToken] = useState(localStorage.getItem("token") || "");
  const [isAdmin, setIsAdmin] = useState(Number(localStorage.getItem("isAdmin")) || 0);
  const [activeTab, setActiveTab] = useState(0);
  const [showSidebar, setShowSidebar] = useState(true);
  
  useEffect(() => {
    let side = localStorage.getItem("showSidebar");
    if (side === "false") {
      setShowSidebar(false);
    }
  }, []);
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) { 
      setUserToken(token);
      setUserLoggedIn(true);
    }
  }, []);

  const data = {
    activeTab,
    setActiveTab,
    showSidebar,
    setShowSidebar,
    userLoggedIn,
    setUserLoggedIn,
    userToken,
    setUserToken,
    setIsAdmin,
    isAdmin
  };

  return (
    <UserContext.Provider value={data}>{props.children}</UserContext.Provider>
  );
}
